var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Close, KeyboardArrowDownRounded } from '@mui/icons-material';
import { Box, Checkbox, CircularProgress, FormControl, FormControlLabel, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, Stack, TextField, Typography, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import config from 'app/config';
import { MapFilterReportGeofenceList } from 'app/pages/Map';
import { useAsyncAction, useStateRef } from 'app/services';
import { geofenceGroupLoad } from 'app/store/map';
import { reportTypeLoad } from 'app/store/report';
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { useSelector } from 'react-redux';
const MapFilterReportForm = forwardRef((props, ref) => {
    const theme = useTheme();
    const transportCheckedItems = useSelector((state) => state.map.transportFilterCheckedType === 'filter' ? state.map.transportProcessingCheckedItems : state.map.transportCheckedItems);
    const { timezone } = useSelector((state) => state.session);
    const roleId = useSelector((state) => { var _a; return (_a = state.session.session) === null || _a === void 0 ? void 0 : _a.role_id; });
    const sessionReportTypes = useSelector((state) => { var _a; return (_a = state.session.session) === null || _a === void 0 ? void 0 : _a.report_types; });
    const { typeItems } = useSelector((state) => state.report);
    const { geofenceItems } = useSelector((state) => state.map);
    const { asyncAction: fetchTypeData, isLoading: isFetchTypeLoading } = useAsyncAction(reportTypeLoad);
    const { asyncAction: fetchGroupData, isLoading: isFetchGroupLoading } = useAsyncAction(geofenceGroupLoad);
    const [geofenceSearchValue, setGeofenceSearchValue] = useState('');
    const [firstUpdate, setFirstUpdate, firstUpdateRef] = useStateRef(false);
    const { onSubmit } = props;
    const { control, watch, register, unregister, formState, setValue, handleSubmit, setError, clearErrors } = useForm({
        defaultValues: {
            type_id: '',
            sort: 'number',
            from: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            to: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
            timezone: timezone,
            geofence_ids: [],
        },
    });
    const typeIdWatch = watch('type_id');
    const fromWatch = watch('from');
    const toWatch = watch('to');
    const geofenceId = watch('geofence_ids');
    const filterTypes = useMemo(() => {
        const canSeeSepEvents = [config.userRoles.SUPERADMIN, config.userRoles.ADMIN, config.userRoles.ENGINEER].includes(roleId);
        const allowedMethods = Array.isArray(sessionReportTypes) ? new Set(sessionReportTypes) : null;
        return typeItems.filter((type) => {
            if (type.method === 'user_log')
                return false;
            if (type.method === 'sep_events' && !canSeeSepEvents)
                return false;
            if (allowedMethods && type.method && !allowedMethods.has(type.method))
                return false;
            return true;
        });
    }, [typeItems, roleId, sessionReportTypes]);
    const sortTypes = useMemo(() => {
        switch (typeIdWatch) {
            case 5:
                return [{ value: 'datetime', title: 'Начало рейса' }];
            default:
                return [
                    { value: 'number', title: 'Госномер' },
                    { value: 'datetime', title: 'Времени события' },
                ];
        }
    }, [typeIdWatch]);
    const geofenceSortItems = useMemo(() => {
        if (geofenceSearchValue.length) {
            return geofenceItems.filter((item) => item.name.toLowerCase().indexOf(geofenceSearchValue.toLowerCase()) !== -1);
        }
        return geofenceItems;
    }, [geofenceItems, geofenceSearchValue]);
    const handleChangeFromDatetime = (newValue) => {
        if (newValue === null || newValue === void 0 ? void 0 : newValue.isValid()) {
            setValue('from', moment(newValue).format('YYYY-MM-DD HH:mm:ss'));
            clearErrors('from');
        }
        else {
            setError('from', { type: 'required' });
        }
    };
    const handleChangeToDatetime = (newValue, keyboardInputValue) => {
        if (newValue === null || newValue === void 0 ? void 0 : newValue.isValid()) {
            setValue('to', moment(keyboardInputValue ? newValue : newValue.endOf('day')).format('YYYY-MM-DD HH:mm:ss'));
            clearErrors('to');
        }
        else {
            setError('to', { type: 'required' });
        }
    };
    const handleGeofenceInputChange = (value) => {
        setGeofenceSearchValue(value);
    };
    const handleGeofenceItemClick = (id) => {
        if (geofenceId.includes(id)) {
            setValue('geofence_ids', geofenceId.filter((geofenceId) => geofenceId !== id));
        }
        else {
            setValue('geofence_ids', [...geofenceId, id]);
        }
    };
    useImperativeHandle(ref, () => ({
        handleFormSubmit: () => {
            handleSubmit((data) => onSubmit({
                type_id: parseInt(String(data.type_id), 10),
                timezone: String(data.timezone),
                sort: data.sort,
                from: data.from,
                to: data.to,
                ids: transportCheckedItems.join(','),
                geofence_ids: Array.isArray(data.geofence_ids) ? data.geofence_ids : [],
                min_parking_time: data.min_parking_time ? data.min_parking_time : undefined,
                max_parking_distance: data.max_parking_distance ? data.max_parking_distance : undefined,
                geofence_known: data.geofence_known !== false,
                geofence_unknown: !!data.geofence_unknown,
                drain_diff: data.drain_diff ? data.drain_diff : undefined,
            }))();
        },
    }));
    useLayoutEffect(() => {
        if (firstUpdateRef.current !== undefined) {
            setTimeout(() => setFirstUpdate(undefined), theme.transitions.duration.shorter);
        }
    }, [firstUpdateRef.current]);
    useEffect(() => {
        switch (typeIdWatch) {
            case 1:
            case 3:
            case 5:
                unregister('min_parking_time');
                unregister('max_parking_distance');
                unregister('geofence_known');
                unregister('geofence_unknown');
                unregister('drain_diff');
                break;
            case 2:
                unregister('drain_diff');
                break;
            case 6:
                unregister('min_parking_time');
                unregister('max_parking_distance');
                unregister('geofence_known');
                unregister('geofence_unknown');
                break;
        }
    }, [typeIdWatch]);
    useEffect(() => {
        switch (typeIdWatch) {
            case 5:
                setValue('sort', 'datetime');
                break;
        }
    }, [typeIdWatch]);
    useEffect(() => {
        fetchTypeData();
        fetchGroupData();
    }, []);
    return (React.createElement("form", null,
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormControl, { error: !!formState.errors.type_id, margin: 'normal', variant: 'outlined', fullWidth: true },
                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0422\u0438\u043F \u043E\u0442\u0447\u0435\u0442\u0430"),
                    isFetchTypeLoading && (React.createElement(OutlinedInput, { disabled: true, endAdornment: React.createElement(InputAdornment, { position: 'end' },
                            React.createElement(CircularProgress, { size: 16 })) })),
                    !isFetchTypeLoading && (React.createElement(Controller, { name: 'type_id', control: control, render: ({ field }) => (React.createElement(Select, Object.assign({ label: '\u0422\u0438\u043F \u043E\u0442\u0447\u0435\u0442\u0430', IconComponent: KeyboardArrowDownRounded, MenuProps: {
                                sx: {
                                    '.MuiPaper-root:before': {
                                        display: 'none',
                                    },
                                },
                            } }, register(field.name, {
                            required: true,
                            pattern: /^([0-9]{1,11})?$/iu,
                        }), { notched: firstUpdate, value: field.value, onChange: field.onChange }), filterTypes.map((type, key) => (React.createElement(MenuItem, { key: key, disableRipple: true, value: type.id }, type.name))))) })),
                    React.createElement(FormHelperText, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u043E\u0442\u0447\u0435\u0442\u0430 \u0434\u043B\u044F \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430"))),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormControl, { error: !!formState.errors.sort, margin: 'normal', variant: 'outlined', fullWidth: true },
                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430"),
                    React.createElement(Controller, { name: 'sort', control: control, render: ({ field }) => (React.createElement(Select, Object.assign({ label: '\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430', IconComponent: KeyboardArrowDownRounded, MenuProps: {
                                sx: {
                                    '.MuiPaper-root:before': {
                                        display: 'none',
                                    },
                                },
                            } }, register(field.name, {
                            required: true,
                        }), { notched: firstUpdate, value: field.value, onChange: field.onChange }), sortTypes.map((type, key) => (React.createElement(MenuItem, { key: key, disableRipple: true, value: type.value }, type.title))))) }),
                    React.createElement(FormHelperText, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430")))),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(LocalizationProvider, { dateAdapter: AdapterMoment, adapterLocale: moment.locale('ru') },
                React.createElement(Grid, { item: true, xs: 4.8 },
                    React.createElement(FormControl, { error: !!formState.errors.from, margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(DesktopDatePicker, { label: '\u041D\u0430\u0447\u0430\u043B\u043E', views: ['day'], minDate: moment().subtract(180, 'days'), maxDate: moment(), inputFormat: 'DD.MM.YYYY HH:mm:ss', value: fromWatch ? moment(fromWatch) : null, onChange: handleChangeFromDatetime, renderInput: (_a) => {
                                var { inputRef, inputProps } = _a, rest = __rest(_a, ["inputRef", "inputProps"]);
                                return (React.createElement(TextField, Object.assign({ inputRef: inputRef, inputProps: inputProps }, rest, { error: !!formState.errors.from, sx: {
                                        svg: {
                                            fontSize: '20px',
                                        },
                                    } })));
                            } }),
                        React.createElement(FormHelperText, null, "\u041D\u0430\u0447\u0430\u043B\u043E \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430"))),
                React.createElement(Grid, { item: true, xs: 4.7 },
                    React.createElement(FormControl, { error: !!formState.errors.to, margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(DesktopDatePicker, { label: '\u041A\u043E\u043D\u0435\u0446', views: ['day'], minDate: fromWatch ? moment(fromWatch) : undefined, maxDate: moment(), inputFormat: 'DD.MM.YYYY HH:mm:ss', value: toWatch ? moment(toWatch) : null, onChange: handleChangeToDatetime, renderInput: (_a) => {
                                var { inputRef, inputProps } = _a, rest = __rest(_a, ["inputRef", "inputProps"]);
                                return (React.createElement(TextField, Object.assign({ inputRef: inputRef, inputProps: inputProps }, rest, { error: !!formState.errors.to, sx: {
                                        svg: {
                                            fontSize: '20px',
                                        },
                                    } })));
                            } }),
                        React.createElement(FormHelperText, null, "\u041A\u043E\u043D\u0435\u0446 \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430"))),
                React.createElement(Grid, { item: true, xs: 2.5 },
                    React.createElement(FormControl, { error: !!formState.errors.timezone, margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0427\u0430\u0441\u043E\u0432\u043E\u0439 \u043F\u043E\u044F\u0441"),
                        React.createElement(Controller, { name: 'timezone', control: control, render: ({ field }) => (React.createElement(Select, Object.assign({ label: '\u0427\u0430\u0441\u043E\u0432\u043E\u0439 \u043F\u043E\u044F\u0441', IconComponent: KeyboardArrowDownRounded, MenuProps: {
                                    sx: {
                                        '.MuiPaper-root:before': {
                                            display: 'none',
                                        },
                                    },
                                } }, register(field.name, {
                                required: true,
                                pattern: /^[\d ()+-]{0,4}$/iu,
                            }), { notched: firstUpdate, value: field.value, onChange: field.onChange }), config.timezoneOffsets.map((timezone, key) => (React.createElement(MenuItem, { key: key, disableRipple: true, value: timezone.value }, timezone.title))))) }))))),
        typeIdWatch === 6 && (React.createElement(React.Fragment, null,
            React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormControl, { error: !!formState.errors.drain_diff, margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0420\u0430\u0437\u043D\u0438\u0446\u0430 \u0432\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043C\u0435\u0436\u0434\u0443 \u0441\u043B\u0438\u0432\u0430\u043C\u0438"),
                        React.createElement(InputMask, Object.assign({ mask: '9999', maskChar: '', defaultValue: 120 }, register('drain_diff', {
                            pattern: /^([0-9]{1,4})$/iu,
                            required: true,
                            valueAsNumber: true,
                        })), (inputProps) => (React.createElement(OutlinedInput, Object.assign({ label: '\u0420\u0430\u0437\u043D\u0438\u0446\u0430 \u0432\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043C\u0435\u0436\u0434\u0443 \u0441\u043B\u0438\u0432\u0430\u043C\u0438', notched: firstUpdate, fullWidth: true }, inputProps)))),
                        React.createElement(FormHelperText, null, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0440\u0430\u0437\u043D\u0438\u0446\u0443 \u0432\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043C\u0435\u0436\u0434\u0443 \u0441\u043B\u0438\u0432\u0430\u043C\u0438 \u0432 \u0441\u0435\u043A\u0443\u043D\u0434\u0430\u0445")))))),
        typeIdWatch === 2 && (React.createElement(React.Fragment, null,
            React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(FormControl, { error: !!formState.errors.min_parking_time, margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u043E\u044F\u043D\u043A\u0438"),
                        React.createElement(InputMask, Object.assign({ mask: '9999', maskChar: '', defaultValue: 300 }, register('min_parking_time', {
                            pattern: /^([0-9]{1,4})$/iu,
                            required: true,
                            valueAsNumber: true,
                        })), (inputProps) => (React.createElement(OutlinedInput, Object.assign({ label: '\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u043E\u044F\u043D\u043A\u0438', notched: firstUpdate, fullWidth: true }, inputProps)))),
                        React.createElement(FormHelperText, null, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u043E\u044F\u043D\u043A\u0438 \u0432 \u0441\u0435\u043A\u0443\u043D\u0434\u0430\u0445"))),
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(FormControl, { error: !!formState.errors.max_parking_distance, margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0440\u0430\u0441\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u043C\u0435\u0436\u0434\u0443 \u0441\u0442\u043E\u044F\u043D\u043A\u0430\u043C\u0438"),
                        React.createElement(InputMask, Object.assign({ mask: '9999', maskChar: '', defaultValue: 500 }, register('max_parking_distance', {
                            pattern: /^([0-9]{1,4})$/iu,
                            required: true,
                            valueAsNumber: true,
                        })), (inputProps) => (React.createElement(OutlinedInput, Object.assign({ label: '\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0440\u0430\u0441\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u043C\u0435\u0436\u0434\u0443 \u0441\u0442\u043E\u044F\u043D\u043A\u0430\u043C\u0438', notched: firstUpdate, fullWidth: true }, inputProps)))),
                        React.createElement(FormHelperText, null, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0440\u0430\u0441\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u043C\u0435\u0436\u0434\u0443 \u0441\u0442\u043E\u044F\u043D\u043A\u0430\u043C\u0438 \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u043E\u044F\u043D\u043A\u0438 \u0432 \u043C\u0435\u0442\u0440\u0430\u0445")))),
            React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormControl, { margin: 'normal', variant: 'outlined', fullWidth: true, sx: {
                            '.MuiInputLabel-root.MuiInputLabel-shrink': {
                                color: 'text.secondary',
                            },
                        } },
                        React.createElement(InputLabel, { disableAnimation: firstUpdate, shrink: true }, "\u0413\u0435\u043E\u0437\u043E\u043D\u044B"),
                        isFetchGroupLoading && (React.createElement(OutlinedInput, { disabled: true, notched: true, label: '\u0413\u0435\u043E\u0437\u043E\u043D\u044B', fullWidth: true, endAdornment: React.createElement(InputAdornment, { position: 'end' },
                                React.createElement(CircularProgress, { size: 16 })) })),
                        !isFetchGroupLoading && (React.createElement(React.Fragment, null,
                            React.createElement(OutlinedInput, { label: '\u0413\u0435\u043E\u0437\u043E\u043D\u044B', placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u0435\u043E\u0437\u043E\u043D\u044B', notched: true, value: geofenceSearchValue, onChange: (e) => handleGeofenceInputChange(e.target.value), fullWidth: true, endAdornment: React.createElement(InputAdornment, { position: 'end' },
                                    React.createElement(IconButton, { disableRipple: true, disableTouchRipple: true, onClick: () => handleGeofenceInputChange('') },
                                        React.createElement(Close, { fontSize: 'small' }))), sx: {
                                    '.MuiOutlinedInput-notchedOutline': {
                                        borderBottomRightRadius: '0',
                                        borderBottomLeftRadius: '0',
                                        borderColor: '#d5d5d5!important',
                                    },
                                    '.MuiInputAdornment-positionEnd': Object.assign({ display: 'none', '.MuiButtonBase-root': {
                                            padding: theme.spacing(0),
                                            margin: theme.spacing(0),
                                            svg: {
                                                fontSize: '16px',
                                            },
                                        } }, (geofenceSearchValue.length !== 0 && {
                                        display: 'flex',
                                    })),
                                } }),
                            React.createElement(Box, { component: 'div', sx: (theme) => ({
                                    width: '100%',
                                    height: '180px',
                                    bgcolor: 'background.paper',
                                    border: '1px solid',
                                    borderColor: '#d5d5d5',
                                    borderRadius: theme.shape.borderRadius,
                                    borderTop: '0',
                                    borderTopRightRadius: '0',
                                    borderTopLeftRadius: '0',
                                }) },
                                geofenceSortItems.length !== 0 && (React.createElement(MapFilterReportGeofenceList, { items: geofenceSortItems, checkedId: geofenceId, onClick: handleGeofenceItemClick })),
                                geofenceSortItems.length === 0 && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                                        width: '100%',
                                        height: '100%',
                                        padding: theme.spacing(2),
                                    }) },
                                    React.createElement(Typography, { align: 'center', variant: 'body1', component: 'span' }, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"),
                                    React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'span' }, "\u041D\u0438 \u043E\u0434\u043D\u0430 \u0433\u0435\u043E\u0437\u043E\u043D\u0430 \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0437\u0430\u0434\u0430\u043D\u043D\u044B\u043C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043C"))))))))),
            React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 12, sx: {
                        '.MuiCheckbox-root': {
                            padding: '0 9px',
                            '&:not(.Mui-checked) svg': {
                                color: '#d5d5d5',
                            },
                        },
                    } },
                    React.createElement(FormControlLabel, { label: '\u041D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0445 \u0437\u043E\u043D\u0430\u0445', control: React.createElement(Controller, { name: 'geofence_known', control: control, defaultValue: true, render: ({ field }) => (React.createElement(Checkbox, Object.assign({ size: 'small', disableRipple: true, disabled: !!geofenceId.length, checked: !!field.value, onChange: field.onChange }, register(field.name)))) }) })),
                React.createElement(Grid, { item: true, xs: 12, sx: {
                        '.MuiCheckbox-root': {
                            padding: '0 9px',
                            '&:not(.Mui-checked) svg': {
                                color: '#d5d5d5',
                            },
                        },
                    } },
                    React.createElement(FormControlLabel, { label: '\u0421\u0442\u043E\u044F\u043D\u043A\u0438 \u0432\u043D\u0435 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0445 \u0437\u043E\u043D', control: React.createElement(Controller, { name: 'geofence_unknown', control: control, defaultValue: true, render: ({ field }) => (React.createElement(Checkbox, Object.assign({ size: 'small', disableRipple: true, disabled: !!geofenceId.length, checked: !!field.value, onChange: field.onChange }, register(field.name)))) }) })))))));
});
export default MapFilterReportForm;
